import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'redux';
import styled from 'styled-components';
import { navigateTo } from 'gatsby-link';
import { translate } from 'react-i18next';
import { reduxForm, SubmissionError, Field as Fi } from 'redux-form';
import Form from '../blocks/Form';
import Field from '../fields/Field';
// import Label from '../text/Label';
import InputField from '../fields/InputField';
import Actions from '../blocks/Actions';
import Button from '../buttons/Button';
import CreateButton from '../buttons/CreateButton';
import ActionButton from '../buttons/ActionButton';
// import ActionLinkButton from '../links/ActionLinkButton';
import LinkButtonLink from '../links/LinkButtonLink';
import Message from '../text/Message';
import catchErrors from '../../helpers/catchErrors';

const Error = styled.div`
  flex: 50% 1 1;
  font-size: 14px;

  &:before {
    background: ${({ meta }) => (meta.error ? '#d0d0d0' : '#52bad5 !important')};
    border-radius: 8px;
    content: "";
    display: inline-block;
    height: 8px;
    margin-right: 10px;
    width: 8px;
  }
`;

const PasswordErrors = styled(({ className }) => (
  <ul className={className}>
    <Fi
      name="lowercase"
      component={Error}
    >
      One lowercase character
    </Fi>
    <Fi
      name="uppercase"
      component={Error}
    >
      One uppercase character
    </Fi>
    <Fi
      name="number"
      component={Error}
    >
      One number
    </Fi>
    <Fi
      name="special"
      component={Error}
    >
      One special character
    </Fi>
    <Fi
      name="minlength"
      component={Error}
    >
      8 characters minimum
    </Fi>
  </ul>
))`
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;

  ${({ inverse }) => inverse && `
    color: white;

    div::before {
      background: #fff2;
    }
  `}
`;

class SignupForm extends React.PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    // showLabels: PropTypes.bool,
    error: PropTypes.string,
    valid: PropTypes.bool.isRequired,
    small: PropTypes.bool,
    inverse: PropTypes.bool,
    onCancel: PropTypes.func,
  };

  static defaultProps = {
    // showLabels: false,
    error: null,
    small: false,
    inverse: false,
    onCancel: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  render() {
    const { t, small, inverse, handleSubmit, error, valid, onCancel } = this.props;
    const { showPassword = false } = this.state;
    return (
      <Form onSubmit={handleSubmit}>
        <Field>
          {/* {showLabels && (<Label>Email Address</Label>)} */}
          <Field>
            <InputField
              inverse={inverse}
              name="email"
              type="text"
              placeholder={t('email_placeholder', {
                defaultValue: 'Enter Email Address',
              })}
              label={t('email', {
                defaultValue: 'Email Address',
              })}
              labelType="floating"
            />
          </Field>
        </Field>
        <Field>
          {/* {showLabels && (
            <Label>
              Password
              <ActionLinkButton
                right
                type="button"
                onClick={() => this.setState(() => ({ showPassword: !showPassword }))}
              >{showPassword ? 'Hide' : 'Show'}</ActionLinkButton>
            </Label>
          )} */}
          <Field>
            <InputField
              inverse={inverse}
              name="password"
              type={showPassword ? 'text' : 'password'}
              placeholder={t('password_placeholder', {
                defaultValue: 'Enter Password',
              })}
              label={t('password', {
                defaultValue: 'Password',
              })}
              labelType="floating"
            />
          </Field>
          {!small && (
            <PasswordErrors
              inverse={inverse}
            />
          )}
        </Field>
        <Actions>
          {small ? (
            <ActionButton
              bold
              disabled={!valid}
              fluid={small}
              inverse={inverse}
            >Create a Space</ActionButton>
          ) : (
            <CreateButton
              bold
              disabled={!valid}
              fluid={small}
              inverse={inverse}
            >Sign up</CreateButton>
          )}
          {onCancel && (
            <Button
              bold
              type="button"
              disabled={!valid}
              fluid={small}
              inverse={inverse}
              onClick={onCancel}
            >{t('cancel', 'Cancel')}</Button>
          )}
          {!small && <LinkButtonLink to="/login">Return to login</LinkButtonLink>}
        </Actions>
        {error && (<Message error>{error}</Message>)}
      </Form>
    );
  }
}

export default compose(
  translate(),
  graphql(gql`
    mutation createUser($email: String!, $password: String!) {
      createUser(email: $email, password: $password) {
        validationErrors {
          field
          message
        }
        user {
          _id
          name
        }
        token
      }
    }
  `, {
    name: 'signup',
  }),
  reduxForm({
    form: 'SignupForm',
    onSubmit: async (variables, _, { error, signup, reset, destroy }) => {
      if (!variables.password || variables.password.length === 0) {
        throw new SubmissionError({
          password: 'Required',
        });
      }
      if (!error) {
        const { data } = catchErrors(await signup({ variables }));
        if (data.createUser && data.createUser.token) {
          localStorage.setItem('authToken', data.createUser.token);
          reset();
          destroy();
          navigateTo('/spaces');
        }
      }
    },
    validate: values => {
      const errors = {};
      if (!values.email) {
        errors.email = 'Required';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
      }
      if (!/[a-z]+/.test(values.password)) {
        errors.lowercase = true;
      }
      if (!values.password || values.password.length < 8) {
        errors.minlength = true;
      }
      if (!/\d+/.test(values.password)) {
        errors.number = true;
      }
      if (!/[`!"$?%^&*()_\-+={[}\]:;@'~#|\\<,>.?/]+/.test(values.password)) {
        errors.special = true;
      }
      if (!/[A-Z]+/.test(values.password)) {
        errors.uppercase = true;
      }
      return errors;
    },
  }),
)(SignupForm);



// WEBPACK FOOTER //
// ./src/components/forms/SignupForm.js